import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSelectStyle0 = cosmosIconCss;

const CosmosIconSelect$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSelect extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '65bbbd5f4e6ab1b409743bfaedf6f60f7d796d86', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bce48bfe037e1bb7e5830849a3df72f9604ecb84', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8625345da1fc4b98e798037c0b1977d63dcab501', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 3a1 1 0 0 1 1 1v.5h-1.5V3h.5Zm1 3.5v2h-1.5v-2H16ZM8.5 16v-1.5h-2V16h2ZM3 15a1 1 0 0 0 1 1h.5v-1.5H3v.5Zm0-2.5v-2h1.5v2H3Zm0-6v2h1.5v-2H3ZM4 3a1 1 0 0 0-1 1v.5h1.5V3H4Zm4.5 0h-2v1.5h2V3Zm2 0h2v1.5h-2V3Zm5.187 13.707 3.139 3.144a.452.452 0 0 0 .724-.072l.316-.317a.454.454 0 0 0 0-.644l-3.148-3.153 1.918-1.241a.326.326 0 0 0-.072-.598l-6.134-1.812a.334.334 0 0 0-.416.417l1.81 6.17a.326.326 0 0 0 .587.081l1.276-1.975Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSelectStyle0; }
}, [1, "cosmos-icon-select", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-select"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSelect$1);
            }
            break;
    } });
}

const CosmosIconSelect = CosmosIconSelect$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSelect, defineCustomElement };
